interface Window {
  fbq?: any;
}

export const fbEvent = (eventName: string, params?: any) => {
  if (typeof window !== "undefined" && window?.fbq) {
    window?.fbq("track", eventName, params);
  }
};

export default fbEvent;
